/*
 * @Author: zhaofy
 * @Date: 2018-01-25 22:55:56
 * @Last Modified by: zhaofy
 * @Last Modified time: 2018-03-36 21:31:55
 */
<template>
  <!-- 此商品以下架或者不存在 -->
  <div style="width:100%;height:200px;text-align:center;margin:30px 0px;">
    <img src="//static.kxymall.com//images/NoGoods404.jpg" alt="此商品以下架或者不存在">
  </div>
</template>
<script>
export default {
  name: 'notGood'
}
</script>




// WEBPACK FOOTER //
// notGood.vue?6b2e0967